import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { validateLoginOtp } from "../../Services/authService";
import { showErrorToast, showSuccessToast } from "../../utils/toastUtils";
import Cookies from "js-cookie";
import { BookCheckIcon } from "lucide-react";

const PinInput = ({ inputRefs, onPinChange, onSubmit }) => {
  const [pin, setPin] = useState(["", "", "", "", "", ""]);

  const handleChange = (index, value) => {
    const newPin = [...pin];
    newPin[index] = value;
    setPin(newPin);

    // if (onPinChange) {
    //   onPinChange(newPin.join(''));
    // }

    const fullPin = newPin.join("");
    if (onPinChange) {
      onPinChange(fullPin);
    }

    if (value !== "" && index < 5) {
      inputRefs.current[index + 1].current.focus();
    }

    // Auto-submit when 6 digits are entered
    if (fullPin.length === 6 && onSubmit) {
      onSubmit(fullPin); // Pass the current pin value directly
    }
  };

  const handleBackspace = (index, event) => {
    if (event.key === "Backspace" && index > 0 && pin[index] === "") {
      inputRefs.current[index - 1].current.focus();
    }
  };

  return (
    <div className="flex justify-center md:mb-4 mb-2">
      {pin.map((value, index) => (
        <React.Fragment key={index}>
          <input
            ref={inputRefs.current[index]}
            type="number"
            maxLength={1}
            value={value}
            onChange={(e) => handleChange(index, e.target.value)}
            onKeyDown={(e) => handleBackspace(index, e)}
            className="border border-blue-500 md:w-10 md:h-10 w-9 h-10 text-center mx-1 rounded shadow-lg shadow-blue-600"
            autoFocus={index === 0}
          />
          {index === 2 && (
            <span className="md:mt-2 text-sky-500 ml-1">&ndash;</span>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

const LoginwithOtpModal = ({
  message,
  isModalOpen,
  toggleModal,
  tempToken,
  referenceId,
  title,
  onSuccess,
}) => {
  const inputRefs = useRef(
    Array.from({ length: 6 }).map(() => React.createRef()),
  );
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (currentPin = pin) => {
    if (currentPin.length !== 6) {
      setError("Please enter a 6-digit PIN.");
      return;
    }

    try {
      const result = await validateLoginOtp({
        temp_token: tempToken,
        otp: currentPin,
        reference_id: referenceId,
      });

      if (result.success) {
        showSuccessToast(result.message);
        Cookies.set(
          "authTokenUser",
          result.token || result.data.token || result.data.data.token,
        );

        navigate("/Dashboard");
        onSuccess?.();
        toggleModal();
      } else {
        showErrorToast(result.message);
      }
    } catch (error) {
      showErrorToast("Server error occurred.");
    }
  };

 return (
  isModalOpen && (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/40 backdrop-blur-sm transition-all">
      <div className="relative w-full max-w-md bg-white rounded-2xl shadow-xl overflow-hidden flex flex-col border border-slate-100 z-50">
        
        {/* Header & Typography Section */}
        <div className="px-6 py-8 text-center space-y-5">
          {/* Top Pill / Title */}
          <div className="inline-flex items-center justify-center gap-2 px-3 py-1.5 bg-blue-600 text-blue-50 rounded-full text-sm font-medium">
            <BookCheckIcon className="w-4 h-4" /> 
            <span>{title}</span>
          </div>

          <div className="space-y-1.5">
            <h2 className="text-2xl font-bold text-slate-900 tracking-tight">
              Authenticate Your Account
            </h2>
            <p className="text-sm text-slate-500 font-medium">
             {message}
             
            </p>
          </div>
        </div>

        {/* Input Section */}
        <div className="px-6 pb-8">
          <div className="flex justify-center">
            <PinInput
              inputRefs={inputRefs}
              onPinChange={setPin}
              onSubmit={handleSubmit}
            />
          </div>
          {error && (
            <div className="mt-4 p-2 text-sm font-medium text-center text-rose-600 bg-rose-50 rounded-lg">
              {error}
            </div>
          )}
        </div>

        {/* Footer / Actions Section */}
        <div className="px-6 py-4 bg-slate-50 border-t border-slate-100 flex justify-end gap-3 rounded-b-2xl">
          <button
            type="button"
            onClick={toggleModal}
            className="px-4 py-2 text-sm font-medium text-slate-700 bg-white border border-slate-300 rounded-lg shadow-sm hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-1 transition-colors"
          >
            Close
          </button>
          
          {/* Note: Kept the 'hidden' class here to match your original logic */}
          <button
            type="button"
            onClick={handleSubmit}
            className="hidden px-4 py-2 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-lg shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-1 transition-colors"
          >
            Submit
          </button>
        </div>

      </div>
    </div>
  )
);
};

export default LoginwithOtpModal;
